import { HTMLAttributes } from 'react';
import { Pencil1Icon } from '@radix-ui/react-icons';
import defaultDp from '@/assets/image/default-dp.png';
import { cn } from '@/utils';
import { compressImage, shouldCompress } from '@/utils/imageCompression';

interface IImageUpload extends HTMLAttributes<HTMLDivElement> {
  value?: any;
  // eslint-disable-next-line no-unused-vars
  onChange?: (data: any) => void;
}

export default function ImageUpload({ value, onChange, className, ...props }: IImageUpload) {
  return (
    <div className={cn('form-control relative  w-fit items-center gap-2', className)} {...props}>
      <div className="image-cover relative flex h-[3.7rem] w-[3.7rem] items-center justify-center overflow-hidden rounded-full border object-fill">
        <img src={value || defaultDp} alt="default profile" className="m-auto object-fill" />
      </div>

      <label
        htmlFor="image"
        className="absolute left-[2.3rem] top-[1.7rem] flex h-[1.62rem] w-[1.62rem] cursor-pointer  items-center justify-center overflow-hidden  rounded-full border  border-[#F4F7FE] bg-[#ffffff] text-primary-500 hover:border-primary-700 hover:text-primary-700"
      >
        <Pencil1Icon />
        <input
          type="file"
          id="image"
          className="hidden"
          name="image"
          accept=".png, .jpg,.gif, .svg,.jpeg"
          onChange={async (e) => {
            const file = e.target.files?.[0];
            if (file) {
              try {
                let processedFile = file;
                
                // Check if file needs compression
                if (shouldCompress(file) && file.type.startsWith('image/')) {
                  try {
                    processedFile = await compressImage(file, { maxSizeMB: 1.5 });
                  } catch (compressionError) {
                    alert(`Could not compress image "${file.name}". Please select a smaller file.`);
                    e.target.value = ''; // Clear the input
                    return;
                  }
                } else if (file.size > 2 * 1024 * 1024) {
                  alert(`File "${file.name}" is too large. Maximum size is 2MB.`);
                  e.target.value = ''; // Clear the input
                  return;
                }

                // Create new FileList with processed file
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(processedFile);
                if (onChange) onChange(dataTransfer.files);
              } catch (error) {
                alert(`Error processing file "${file.name}". Please try again.`);
                e.target.value = ''; // Clear the input
              }
            } else {
              if (onChange) onChange(e.target.files);
            }
          }}
        />
      </label>
    </div>
  );
}
